import UtilityProgramLearnMoreDashboardView from 'features/utility-programs/UtilityProgramLearnMoreDashboardView'
import { BatteryStatus } from './BatteryStatus'
import EnergySystemDRAlert from './EnergySystemDRAlert'

export interface Props {
  energySystemId: string
}

export default function EnergySystemSection(props: Props) {
  return (
    <>
      <EnergySystemDRAlert energySystemId={props.energySystemId} />
      <UtilityProgramLearnMoreDashboardView />
      <BatteryStatus energySystemId={props.energySystemId} />
    </>
  )
}
